"use strict";

require("core-js/modules/es.object.from-entries");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isObject = exports.pick = exports.assertNever = void 0;
/**
 * Utility for enforcing exhaustiveness checks in the type system.
 *
 * @see https://basarat.gitbook.io/typescript/type-system/discriminated-unions#throw-in-exhaustive-checks
 *
 * @param value The variable with no remaining values
 */

function assertNever(value) {
  throw new Error("Unexpected value should never occur: ".concat(value));
}

exports.assertNever = assertNever;

function pick(base, keys) {
  var entries = keys.map(function (key) {
    return [key, base === null || base === void 0 ? void 0 : base[key]];
  });
  return Object.fromEntries(entries);
}

exports.pick = pick;

function isObject(o) {
  return typeof o === "object" && o !== null;
}

exports.isObject = isObject;